const user = state => state.customer;
const orderClosed = state => state.orderClosed;
const phoneOptin = state => state.acceptedPhoneOptin;
const emailOptin = state => state.acceptedEmailOptin;
const newsletterOptin = state => state.acceptedNewsletterOptin;
const notifications = state => state.notifications;
const session =  state => state.paymentSession;
export default {
    user,
    orderClosed,
    phoneOptin,
    emailOptin,
    newsletterOptin,
    notifications,
    session
}